import { connect } from 'react-redux';
import { getFormFieldErrorsFromResponseJSON } from 'app/react/helpers/_index';
import { mapBeatswitchContextToProps } from 'app/react/components/util/connectBeatswitchContext';
import * as actions from 'app/react/state/actions/_index';
import * as Driver from 'app/react/entities/events/drivers/index';

import Modal from './Modal';
import * as State from './ModalState';

const FAILED_POPUP = 'Failed to create driver.';
const SUCCESSFUL_POPUP = 'Driver successfully created.';

const mapStateToProps = (state) => {
    const {
        isOpened,
        isSaving,
        values = {},
        errors = {},
    } = State.getCreateModalState(state);
    return {
        ...mapBeatswitchContextToProps(state),
        isCreating: true,
        isOpened,
        values,
        errors,
        isSaving
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSave: (createAnother) => {
        const { values } = stateProps;
        dispatchProps.onSave(createAnother, values);
    }
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClosed: () => {
        dispatch((State.setCreateModalStateValue('isOpened', false)));
    },
    onChangeValue: (key, value) => {
        dispatch(State.setCreateModalStateValue(`values.${key}`, value));
    },
    onSave: (createAnother = false, values) => {
        dispatch((State.setCreateModalStateValue('isSaving', true)));
        dispatch(Driver.thunks.createOneForCurrentContext(values))
            .then(({ error, response }) => {
                if (typeof error !== 'undefined') {
                    const errors = getFormFieldErrorsFromResponseJSON(error);
                    dispatch(actions.showErrorPopup(FAILED_POPUP));
                    dispatch(State.mergeCreateModalState({
                        errors: errors,
                        isSaving: false
                    }));
                } else {
                    if (typeof ownProps.onSaveSuccess === 'function') {
                        ownProps.onSaveSuccess(response.result);
                    }
                    dispatch(actions.showSuccessPopup(SUCCESSFUL_POPUP));
                    dispatch(State.mergeCreateModalState({
                        errors: {},
                        values: {},
                        isOpened: createAnother,
                        isSaving: false
                    }));
                }
            });
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Modal);
